// A job's owner is the person it belongs to: they get the job's Mya thread and
// are shown to hired candidates as the agency contact. The API defaults it to
// whoever creates the job, and keeps it as it is on an edit that leaves
// ownerUserId out.

export function ownerName(owner) {
  if (!owner) return "";
  const name = [owner.firstName, owner.lastName].filter(Boolean).join(" ").trim();
  return name || owner.email || "";
}

/** The current user in the JobOwner shape, the owner a new job defaults to. */
export function ownerFromUser(user) {
  if (!user?.id) return null;
  return {
    id: user.id,
    firstName: user.firstName || "",
    lastName: user.lastName || "",
    email: user.email || "",
    role: user.role || null,
  };
}

/**
 * The ownerUserId to send, or undefined to leave it out. It is only sent when
 * the chosen owner differs from the one the API would keep anyway (the creator
 * on a create, the current owner on an edit), so an owner the caller could not
 * pick themselves (say a Moblyze staff member) is never re-validated.
 */
export function ownerUserIdToSend(selectedOwner, baselineOwnerId) {
  const id = selectedOwner?.id;
  if (!id || id === baselineOwnerId) return undefined;
  return id;
}

/** `{ ownerUserId }` when it should be sent, else `{}`; spread into variables. */
export function ownerUserIdVariables(selectedOwner, baselineOwnerId) {
  const ownerUserId = ownerUserIdToSend(selectedOwner, baselineOwnerId);
  return ownerUserId ? { ownerUserId } : {};
}
